// eslint-disable-next-line import/prefer-default-export
export function setBackgroundImageUrl(image) {
    return image ? `url(${image})` : 'unset';
}
